import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagGerenciaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagGerencia'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagGerencia'
          label='Gerencia'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagGerenciaFormGroup)
